// client/src/utils/logger.js
// Centralized logging utility for client-side that respects environment

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  // Development-only logging
  debug: (...args) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  // Info logs (shown in dev only for client)
  info: (...args) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  // Warning logs (always shown)
  warn: (...args) => {
    console.warn('[WARN]', ...args);
  },

  // Error logs (always shown)
  error: (...args) => {
    console.error('[ERROR]', ...args);
  },

  // API call logging (development only)
  api: (method, endpoint, data) => {
    if (isDevelopment) {
      console.log(`[API] ${method} ${endpoint}`, data || '');
    }
  }
};

export default logger;
